define('resourcerefinementlist',["instantsearch", "jquery", "mustache", "algoliasearch", "algoliasearchhelper", "eventManager"],
    function (instantsearch, $, mustache, algoliasearch, algoliasearchhelper, eventManager) {
        instantsearch.widgets.resourceRefinementList = function resourceRefinementList(options, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, languageFacet) {

            var configOptions = options;
            var facetName = options.attribute;
            var resultsHelper = null;
            var container = document.querySelector(options.container);
            var client = algoliasearch(algoliaApplicationId, algoliaApiKey);
            var resourceFacetHelper = algoliasearchhelper(client, algoliaIndexName, {
                facets: [facetName, languageFacet],
                facetsRefinements: {
                    _language: [contextLanguage]
                }
            });
            var selectedRefinements = [];

            var initialResourceFacets = [];

            resourceFacetHelper.on('result', function (data) {

                if (initialResourceFacets.length === 0) {
                    if (data.facets[0].name === facetName) {
                        var levelOneFacet = data.facets[0].data;

                        for (var firstLevelFacetName in levelOneFacet) {
                            var indexInResult = $.inArray(firstLevelFacetName, initialResourceFacets);

                            if (indexInResult === -1) {
                                var firstLevelFacet = {
                                    name: firstLevelFacetName,
                                    count: levelOneFacet[firstLevelFacetName],
                                    itemClass: configOptions.cssClasses.item,
                                    listClass: configOptions.cssClasses.list,
                                    countClass: configOptions.cssClasses.count,
                                    nameClass: configOptions.cssClasses.name,
                                    checked: false,
                                    data: null
                                }
                                initialResourceFacets.push(firstLevelFacet);
                            }
                        }
                    }
                }

                //search is done from resourceFacetHelper render event to avoid racing condition with resultsHelper render events
                if (resultsHelper != null) {
                    resultsHelper.clearRefinements(facetName);
                    Object.keys(selectedRefinements).map(function (key) {
                        if (key === facetName) {
                            $(selectedRefinements[key]).each(function (index) {
                                resultsHelper.toggleFacetRefinement(key, selectedRefinements[key][index]);
                            });
                        }
                    });

                    resultsHelper.search();
                    eventManager.trigger("SearchFiltersUpdated");
                }

            });

            eventManager.subscribe("ToggleSearchFilter", function (data) {
                if (data.facetName === facetName) {
                    var $listItem = $(container).find('li[data-hierarchicalname="' + data.value + '"]');

                    if ($listItem) {
                        resourceItemClickEvent($listItem, null);
                    };
                }
                else {
                    selectedRefinements = resourceFacetHelper.state.facetsRefinements;
                    resourceFacetHelper.search();
                };
            });

            resourceFacetHelper.search();

            mapAndRenderReturnedFacets: function mapAndRenderReturnedFacets(results) {

                var html = "<ul class='" + configOptions.cssClasses.list + "'>";
                initialResourceFacets.sort(function (a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                initialResourceFacets.map(function (item, index) {
                    var resourceFacetNames = $(results.facets).map(function (index, item) {
                        return item.name;
                    });
                    var resourceFacetIndex = $.inArray(facetName, resourceFacetNames);
                    var indexInResult = -1;
                    var returnedFacetValues = [];

                    if (resourceFacetIndex > -1) {
                        returnedFacetValues = results.getFacetValues(facetName, null);
                        var returnedFacetNames = $(returnedFacetValues).map(function (index, item) {
                            return item.name;
                        });
                        indexInResult = $.inArray(item.name, returnedFacetNames);
                    }

                    var facetItem = {};

                    if (indexInResult === -1) {
                        facetItem = item;
                        facetItem.itemClass = configOptions.cssClasses.item + ' disabled';
                        facetItem.count = 0;
                        facetItem.disabled = true;
                    }
                    else {
                        facetItem = returnedFacetValues[indexInResult];
                        facetItem.itemClass = configOptions.cssClasses.item;
                        facetItem.disabled = facetItem.count <= 0;
                    }

                    var generatedId = Math.floor((Math.random() * 10000) + 1);
                    facetItem.id = 'r-' + index + '-' + generatedId;
                    facetItem.listClass = configOptions.cssClasses.list;
                    facetItem.countClass = configOptions.cssClasses.count;
                    facetItem.nameClass = configOptions.cssClasses.name;

                    var selectedRefinementNames = [];
                    Object.keys(selectedRefinements).map(function (key) {
                        $(selectedRefinements[key]).each(function (index) {
                            selectedRefinementNames.push(selectedRefinements[key][index]);
                        });
                    });

                    facetItem.checked = $.inArray(facetItem.name, selectedRefinementNames) > -1;

                    html += mustache.render("<li class='{{itemClass}}' data-hierarchicalname='{{name}}'><input type='checkbox' id='{{id}}' {{#checked}}checked{{/checked}} {{#disabled}}disabled='disabled'{{/disabled}}/> <label class='{{nameClass}}' for='{{id}}'>{{name}}</label></a> <span class='{{countClass}}'>{{count}}</span></li>", facetItem);

                });

                html += "</ul>";

                return html;
            };

            cancelBubble = function cancelBubble(e) {
                var evt = e ? e : window.event;
                if (evt.stopPropagation) evt.stopPropagation();
                if (evt.cancelBubble != null) evt.cancelBubble = true;
            };

            resourceItemClickEvent = function (that, e) {
                cancelBubble(e);
                var $relatedCheckBox = $(that).find('input[type="checkbox"]').filter(':first');

                if ($relatedCheckBox.is('[disabled=disabled]') && !$relatedCheckBox.prop("checked")) {
                    return false;
                }

                $relatedCheckBox.prop("checked", !$relatedCheckBox.prop("checked"));

                resourceFacetHelper.state.facetsRefinements = selectedRefinements;

                var facetValue = $relatedCheckBox.parent().data('hierarchicalname');

                resourceFacetHelper.toggleFacetRefinement(facetName, facetValue);

                selectedRefinements = resourceFacetHelper.state.facetsRefinements;

                resourceFacetHelper.search();

                return false;
            };

            return {
                // Method called at startup, to configure the Algolia settings
                getConfiguration: function getConfiguration() {
                    return {
                        facets: [configOptions.attribute]
                    };
                },

                // Called on the first instantsearch search
                init: function init(options) {
                    var helper = options.helper;

                    resultsHelper = helper;
                    selectedRefinements = helper.state.facetsRefinements;
                },

                // Called whenever we receive new results from Algolia
                render: function render(options) {
                    var helper = options.helper;

                    var html = mapAndRenderReturnedFacets(options.results);

                    $(container).html(html);

                    var $firstLvlItemElements = $(container).find('.' + configOptions.cssClasses.item);

                    $firstLvlItemElements.on('click', function (e) {

                        cancelBubble(e);

                        var $relatedCheckBox = $(this).find('input[type="checkbox"]').filter(':first');

                        if ($relatedCheckBox.is('[disabled=disabled]') && !$relatedCheckBox.prop("checked")) {
                            return false;
                        }

                        $relatedCheckBox.prop("checked", !$relatedCheckBox.prop("checked"));

                        resourceFacetHelper.state.facetsRefinements = selectedRefinements;

                        var facetValue = $relatedCheckBox.parent().data('hierarchicalname');

                        resourceFacetHelper.toggleFacetRefinement(facetName, facetValue);

                        selectedRefinements = resourceFacetHelper.state.facetsRefinements;

                        resourceFacetHelper.search();

                        return false;
                    });

                    resultsHelper = options.helper;
                },
                clearAll: function clearAll() {
                    resultsHelper.clearRefinements(facetName);
                    resourceFacetHelper.clearRefinements(facetName);
                    selectedRefinements = resourceFacetHelper.state.facetsRefinements;
                    resultsHelper.search();
                }
            }
        };
    });
